const CONSTANTS = {
    RUPEE_SIGN: "₹",
    FORMAT_DOB: "DD/MM/YYYY",
    FORMAT_DOB_SLASH: "YYYY-MM-DD",
    FORMAT_SLOT_DATE: "DD-MMM-YYYY",
    NA: 'NA',
    SCHEDULE: "SCHEDULE",
    INSTANT: "INSTANT"
}

export default CONSTANTS;